import React from 'react'

import HelpCenterLayout from '../../components/Layout'

import ROUTE from './route'
import { Props } from './data'

import { PageConfig } from 'src/routing/types'

const HelpCenterTopic: PageConfig<Props> = (props) => (
  <HelpCenterLayout {...props} topicSlug={props.topicSlug || undefined} />
)

HelpCenterTopic.route = ROUTE

export { getStaticPaths, getStaticProps } from './data'
export default HelpCenterTopic
